import { render, staticRenderFns } from "./user-logs.vue?vue&type=template&id=03df5384&scoped=true&"
import script from "./user-logs.vue?vue&type=script&lang=js&"
export * from "./user-logs.vue?vue&type=script&lang=js&"
import style0 from "./user-logs.vue?vue&type=style&index=0&id=03df5384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03df5384",
  null
  
)

export default component.exports